// Shared category accent palette (per Restful Night-Mode pivot).
// Applied consistently across Dashboard, History, AnalysisModal, and any
// future components that surface categories.
//
// User-defined mappings (5 confirmed + 5 approved picks):
//   Finance         \u2192 Gold          (#D4AF37)
//   Family          \u2192 Terracotta    (#C87355)
//   Education       \u2192 Sage Green    (#8FA26B)
//   Love/Relations  \u2192 Crimson       (#B03A48)
//   Divine Purpose  \u2192 Warm Sand     (#D4B896)
//   Health          \u2192 Muted Teal    (#5D8A8A)
//   Career          \u2192 Bronze        (#A67C52)
//   Spiritual Grw   \u2192 Deep Violet   (#6B4E8C)
//   Relationships   \u2192 Blush Rose    (#C48B94)
//   Wisdom          \u2192 Cobalt        (#4A6B9D)

export const CATEGORY_ACCENTS = {
  'Finances':                { hex: '#D4AF37', label: 'Gold' },
  'Family & Relationships':  { hex: '#C87355', label: 'Terracotta' },
  'Education & Wisdom':      { hex: '#8FA26B', label: 'Sage Green' },
  'Relationships':           { hex: '#B03A48', label: 'Crimson' },
  'Faith & Ministry':        { hex: '#D4B896', label: 'Warm Sand' },
  'Health & Wellness':       { hex: '#5D8A8A', label: 'Muted Teal' },
  'Business & Career':       { hex: '#A67C52', label: 'Bronze' },
  'Spiritual Warfare':       { hex: '#6B4E8C', label: 'Deep Violet' },
  'Personal Growth':         { hex: '#C48B94', label: 'Blush Rose' },
  'Emotional & Mental':      { hex: '#4A6B9D', label: 'Cobalt' },
};

const DEFAULT_ACCENT = { hex: '#D4AF37', label: 'Gold' };

export const getCategoryAccent = (name) => CATEGORY_ACCENTS[name] || DEFAULT_ACCENT;

export const getCategoryHex = (name) => getCategoryAccent(name).hex;

/**
 * Returns Tailwind class string producing a tinted badge for the category.
 * We tint the accent color at low opacity for background/border and use a
 * theme-aware text token so the badge reads on both light and dark backdrops.
 */
export const getCategoryBadgeClass = (name) => {
  const { hex } = getCategoryAccent(name);
  return `bg-[${hex}]/15 text-[var(--sd-fg)] border border-[${hex}]/50 font-semibold`;
};

/**
 * Inline style variant (safer than dynamic Tailwind arbitrary values which can
 * fail to be picked up by JIT if the class string is constructed at runtime).
 */
export const getCategoryBadgeStyle = (name) => {
  const { hex } = getCategoryAccent(name);
  return {
    backgroundColor: `${hex}26`,   // ~15% alpha
    borderColor: `${hex}80`,        // ~50% alpha
    color: 'var(--sd-fg)',
  };
};
